import { Container, Skeleton } from '@chakra-ui/react';
import FormLoader from '@core/components/Loader/Form/FormLoader';
import { lazyLoad } from '@core/utils/loadable';

export default lazyLoad(
  () => import('./index'),
  <Container maxW="container.lg" my={24}>
    <Skeleton w="50%" minW="180px" h="32px" mb={6} />
    <FormLoader maxW="container.md" mx="auto" my={24} inputs={4} label textarea button />
  </Container>,
);
